import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
    this.AssessTempValidation = function () {
        const dictonary = {
            custom: {
                Type: {
                    required: () => t.t(dictEnum.LBL_Type) + t.t(dictEnum.WARN_IsRequired)
                },
                CDesc: {
                    required: () => t.t(dictEnum.LBL_ChiDesc) + t.t(dictEnum.WARN_IsRequired)
                },
                EDesc: {
                    required: () => t.t(dictEnum.LBL_EngDesc) + t.t(dictEnum.WARN_IsRequired)
                },
                Grp: {
                    required: () => t.t(dictEnum.LBL_Group) + t.t(dictEnum.WARN_IsRequired)
                },
                Item: {
                    required: () => t.t(dictEnum.LBL_Item) + t.t(dictEnum.WARN_IsRequired)
                },
                OptValue: {
                    required: () => t.t(dictEnum.LBL_Option) + t.t(dictEnum.WARN_IsRequired)
                },
            }
        };
        Validator.localize('en', dictonary);
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S081800-AssessTemp/S081800-AssessTempValidation.js